import { create } from 'zustand'

import { clearDatadogUser, setDatadogUser } from 'modules/datadog'

import { AuthPayload, AuthState, authAdapter } from '../utils/auth/authAdapter'

type UseAuthStore = AuthState & {
  hydrate: () => void
  setAuth: (payload: AuthPayload) => void
  logout: () => void
}

export const useAuth = create<UseAuthStore>((set) => {
  // Initialize with pre-hydrated state from storage
  const initialStateData = authAdapter.getAuthFromStorage()

  return {
    ...initialStateData,

    // Sync from storage → Zustand - keep for special cases
    hydrate: () => {
      const data = authAdapter.getAuthFromStorage()
      set(data)
      setDatadogUser(data)
    },

    // Used after successful registration to 'auto-login' user like it is done in the legacy buyflow
    setAuth: (payload) => {
      /**
       * Retro-compatible logic to match legacy implementation
       */
      authAdapter.setAuthToStorage(payload)

      // Get updated state from storage after setting auth
      const data = authAdapter.getAuthFromStorage()
      set(data)
      setDatadogUser(data)

      // TODO: Are we going to notify the legacy app somehow?
    },

    // In case we need to logout the user
    logout: () => {
      authAdapter.clearAuthStorage()

      set({
        token: null,
        idToken: null,
        user: null,
        isAuthenticated: false
      })

      clearDatadogUser()
    }
  }
})
